import React from 'react'
import { MembershipTaskListContextProvider } from '../../features/MembershipTaskList/MembershipTaskListContextProvider'
import EditUpgradeMembershipTaskListForm from '../../features/MembershipTaskList/EditUpgradeMembershipTaskListForm'

const EditUpgradeMembershipTaskList = () => {
  return (
    <MembershipTaskListContextProvider>
        <EditUpgradeMembershipTaskListForm/>
    </MembershipTaskListContextProvider>
    
  )
}

export default EditUpgradeMembershipTaskList